import { call, put, take } from 'redux-saga/effects';
import { api } from 'rp-auth';
import {
  subscriptionConfirmFailed,
  subscriptionConfirmSucceeded,
  SUBSCRIPTION_CONFIRM,
} from '../actions/subscriptions';

const { confirmSubscription } = api;

export const gotoPaymentPageUrl = (sessionId) => {
  const { paymentPageUrl } = global.__PRELOADED_STATE__.config;
  global.history.pushState({}, '', '/subscriptions');
  global.location.assign(`${paymentPageUrl}/?guid=${sessionId}`);
};

export default function* () {
  while (true) {
    const action = yield take(SUBSCRIPTION_CONFIRM);

    try {
      yield call(confirmSubscription, action.payload);
      yield put(subscriptionConfirmSucceeded());
      yield call(gotoPaymentPageUrl, action.payload.sessionId);
    } catch (error) {
      yield put(subscriptionConfirmFailed(error));
    }
  }
}
